// Lightweight gtag wrapper — sends events directly to GA4 (no GTM needed)
// GA4 Measurement ID
export const GA_MEASUREMENT_ID = 'G-2RPRLHR8VL';

type GtagEventParams = Record<string, string | number | boolean | undefined>;

/** Fire a GA4 event via the global gtag() function loaded in index.html */
export function trackEvent(eventName: string, params?: GtagEventParams) {
  if (typeof window !== 'undefined' && typeof (window as any).gtag === 'function') {
    (window as any).gtag('event', eventName, params);
  }
}

// ── Pre-built event helpers ─────────────────────────────────────────────

export const trackPhoneClick = (pageUrl?: string) =>
  trackEvent('phone_call_click', { link_url: 'tel:+17047073620', page_location: pageUrl ?? window.location.href });

export const trackSmsClick = (smsUrl: string, pageUrl?: string) =>
  trackEvent('sms_click', { link_url: smsUrl, page_location: pageUrl ?? window.location.href });

export const trackDirectionsClick = (pageUrl?: string) =>
  trackEvent('directions_click', { page_location: pageUrl ?? window.location.href });

export const trackEmailClick = (pageUrl?: string) =>
  trackEvent('email_click', { page_location: pageUrl ?? window.location.href });

export const trackMapClick = (pageUrl?: string) =>
  trackEvent('map_click', { link_url: 'google_maps', page_location: pageUrl ?? window.location.href });

export const trackSocialClick = (platform: string, url: string) =>
  trackEvent('social_media_click', { link_url: url, social_platform: platform, page_location: window.location.href });

export const trackFinancingClick = (provider: string, url: string) =>
  trackEvent('financing_click', { link_url: url, provider, page_location: window.location.href });

export const trackMembershipClick = (url: string) =>
  trackEvent('membership_click', { link_url: url, page_location: window.location.href });

export const trackOutboundClick = (url: string, text?: string) =>
  trackEvent('outbound_link_click', { link_url: url, link_text: text, page_location: window.location.href });

export const trackChatSend = () =>
  trackEvent('chat_send', { page_location: window.location.href });

export const trackChatVoiceCall = () =>
  trackEvent('chatbot_voice_call', { page_location: window.location.href });

export const trackChatInsuranceUpload = () =>
  trackEvent('chatbot_insurance_upload', { page_location: window.location.href });

export const trackChatQuickAction = (text: string) =>
  trackEvent('chatbot_quick_action', { click_text: text, page_location: window.location.href });

export const trackChatPhoneClick = (url: string) =>
  trackEvent('chatbot_phone_click', { link_url: url, page_location: window.location.href });

export const trackBookAppointmentSuccess = () =>
  trackEvent('book_appointment_success', { page_location: window.location.href });

export const trackContactFormSuccess = () =>
  trackEvent('contact_form_success', { page_location: window.location.href });

export const trackCallbackSuccess = () =>
  trackEvent('call_back_success', { page_location: window.location.href });

export const trackConfirmBooking = () =>
  trackEvent('Confirm-Booking', { page_location: window.location.href });

export const trackSubmitPayment = () =>
  trackEvent('Submit-Payment', { page_location: window.location.href });
